import http from "~/common/http";

/**
 * 回访类型
 */
export const TYPE_NEW = 1; // 新客户回访
export const TYPE_OLD = 2; // 老客户回访

/**
 * 回访方式
 */
export const METHOD_PHONE = 1; // 电话回访
export const METHOD_SMS = 2; // 短信回访
export const METHOD_ONLINE = 3; // 在线沟通

/**
 * 回访状态
 */
export const STATUS_INVALID = 0; // 无效访问
export const STATUS_OK = 1; // 有效回访

// 客户回访模型对象
export const CustomerVisit = {
    id: 0,
    customer_id: "",
    user_id: "",
    contact_id: "",
    type: "",
    method: "",
    category: "",
    is_send: "",
    email: "",
    status: "",
    products: [],
    content: "",
    next_time: "",
    sales_rate: ""
};

/**
 * 业务员评价
 * @type {number}
 */
export const RATE_A = 1; // 满意
export const RATE_B = 3; // 不满意

// 回访服务
export const VisitService = {

    /**
     * 获取回访类型
     * @returns {{[p: string]: string, [p: number]: string}}
     */
    getTypes() {
        return {
            [TYPE_NEW]: "新客户回访",
            [TYPE_OLD]: "老客户回访",
        }
    },

    /**
     * 获取回访方式
     * @returns {{[p: string]: string, [p: number]: string}}
     */
    getMethods() {
        return {
            [METHOD_PHONE]: "电话回访",
            [METHOD_SMS]: "短信回访",
            [METHOD_ONLINE]: "在线沟通"
        }
    },

    /**
     * 回访状态
     * @returns {{[p: string]: string, [p: number]: string}}
     */
    getStatus() {
        return {
            [STATUS_INVALID]: "无效回访",
            [STATUS_OK]: "有效回访"
        }
    },

    /**
     * 获取业务员评价列表
     * @returns {{[p: string]: string, [p: number]: string}}
     */
    getRates() {
        return {
            [RATE_A]: "满意",
            [RATE_B]: "不满意"
        }
    },

    getList(params) {
        return http.get('/api/customer/visits/index', {
            params: params
        });
    },

    create(data) {
        return http.post('/api/customer/visits/create', data);
    },

    /**
     * 删除回访记录
     * @param id
     * @returns {*}
     */
    delete(id) {
        return http.delete('/api/customer/visits/delete', {
            params: {id: id}
        });
    },

    /**
     * 获取回访详细信息
     * @param id
     * @returns {*}
     */
    getInfo(id) {
        return http.get('/api/customer/visits/view', {
            params: {id: id}
        });
    },

    /**
     * 获取回访问题类型
     * @returns {*}
     */
    getQuestionCategories() {
        return http.get('/api/customer/visits/categories');
    },


};


// WEBPACK FOOTER //
// ./src/services/CustomerVisit.js